import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import Redo from "@mui/icons-material/Redo";
import Undo from "@mui/icons-material/Undo";
import { IconButton, Tooltip } from "@mui/material";
import { CAN_REDO_COMMAND, CAN_UNDO_COMMAND, REDO_COMMAND, UNDO_COMMAND } from "lexical";
import type { FC } from "react";
import { useEffect, useState } from "react";
import type { ToolbarProps } from "./props";

export const UndoRedoButtons: FC<Omit<ToolbarProps, "mode">> = ({ disabled }) => {
  const [editor] = useLexicalComposerContext();
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        CAN_UNDO_COMMAND,
        (payload: boolean) => {
          setCanUndo(payload);
          return false;
        },
        1,
      ),
      editor.registerCommand(
        CAN_REDO_COMMAND,
        (payload: boolean) => {
          setCanRedo(payload);
          return false;
        },
        1,
      ),
    );
  }, [editor]);

  return (
    <>
      <Tooltip title="Undo">
        <span>
          <IconButton
            data-analytics-id="lexical-toolbar-undo"
            data-testid="toolbar-button-undo"
            aria-label="Undo"
            tabIndex={-1}
            disabled={disabled || !canUndo}
            onClick={() => editor.dispatchCommand(UNDO_COMMAND, undefined)}
          >
            <Undo />
          </IconButton>
        </span>
      </Tooltip>
      <Tooltip title="Redo">
        <span>
          <IconButton
            data-analytics-id="lexical-toolbar-redo"
            data-testid="toolbar-button-redo"
            aria-label="Redo"
            tabIndex={-1}
            disabled={disabled || !canRedo}
            onClick={() => editor.dispatchCommand(REDO_COMMAND, undefined)}
          >
            <Redo />
          </IconButton>
        </span>
      </Tooltip>
    </>
  );
};
